import React, {useState} from 'react'
import {Button, Card, DatePicker, Divider, Image, Modal, Select, Space, Typography} from "antd";
import {Column} from '@ant-design/plots';
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import moment from "moment";
import {VscsApi} from "../../services/VscsApi";
import {useMount} from "ahooks";
import {useNavigate} from "react-router-dom";
import {ApiService} from "../../services/ApiService";
import {CommonApi} from "../../services/CommonApi";
import {ExclamationCircleOutlined} from "@ant-design/icons";

const {confirm} = Modal;

const {RangePicker} = DatePicker;
const {Text} = Typography
const {Option} = Select;

const VscsFlowHomePage = () => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [dateRage, setDateRange] = useState([]);
    const [data, setData] = useState([]);
    const [venues, setVenues] = useState([]);

    const [religions, setReligions] = useState([])
    const [regions, setRegions] = useState([])
    const [selectedRegion, setSelectRegion] = useState(null)
    const [selectedReligion, setSelectedReligion] = useState("-1")

    const [mixMode, setMixMode] = useState(false);
    const [mixPersons, setMixPersons] = useState(new Set());

    const requestData = () => {
        setLoading(true)
        VscsApi.flow(dateRage[0], dateRage[1], selectedRegion, selectedReligion)
            .onSuccess(_data => {
                const d = _data.map(d => {
                    return {
                        ...d, value: Number(d.value)
                    }
                })
                setData([...d])
            })
            .onComplete(() => {
                setLoading(false)
            })

        VscsApi.flowPerson(dateRage[0], dateRage[1], selectedRegion, selectedReligion)
            .onSuccess(setVenues)
    }

    useMount(() => {
        ApiService.constants.religion()
            .onSuccess(data => {
                setReligions([...data])
            })
        CommonApi.regionChildrenLimit(3)
            .onSuccess(regions => {
                setRegions([...regions])
            })
        requestData()
    })

    const config = {
        data, isStack: true, xField: 'venue', yField: 'value', seriesField: 'type', label: {
            // 可手动配置 label 数据标签位置
            position: 'middle', // 'top', 'bottom', 'middle'
            // 可配置附加的布局方法
            layout: [// 柱形图数据标签位置自动调整
                {
                    type: 'interval-adjust-position',
                }, // 数据标签防遮挡
                {
                    type: 'interval-hide-overlap',
                }, // 数据标签文颜色自动调整
                {
                    type: 'adjust-color',
                },],
        },
    };

    const handleDateRangeChange = (dates) => {
        setDateRange([...dates])
    }

    const handleSearchClick = () => {
        requestData()
    }

    const handlePersonClick = (person) => {
        if (mixMode) {
            const _mixPerson = new Set([...mixPersons])
            if (_mixPerson.has(person)) {
                _mixPerson.delete(person)
            } else {
                _mixPerson.add(person)
            }
            setMixPersons(_mixPerson)
        } else {
            window.open('/#/vscs/person/timeline?id=' + person.id)
        }
    }

    const getMixModeButtons = () => {
        if (!mixMode) {
            return <Space>
                <Select
                    showSearch
                    placeholder="按地区筛选"
                    optionFilterProp="children"
                    defaultValue={selectedRegion}
                    onChange={value => setSelectRegion(value)}
                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                    {regions.map(r => <Option value={r.code}>{r.name}</Option>)}
                </Select>
                <Select
                    showSearch
                    placeholder="按宗教类型筛选"
                    optionFilterProp="children"
                    defaultValue={selectedReligion}
                    onChange={value => setSelectedReligion(value)}
                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                    <Option value="-1">全部</Option>
                    {religions.map(r => <Option value={r.value}>{r.name}</Option>)}
                </Select>
                <RangePicker locale={locale}
                             showToday
                             defaultValue={[moment(), moment()]}
                             onChange={handleDateRangeChange}/>
                <Button loading={loading} onClick={handleSearchClick}>查询</Button>
                <Button onClick={e => {
                    e.preventDefault()
                    setMixMode(true)
                }}>合并模式</Button>
            </Space>

        } else {
            return <Space>
                <span style={{color: '#95989a'}}>合并模式下，在页面中连续选择相同的人物来快速合并</span>
                <Button onClick={e => {
                    e.preventDefault()
                    setMixMode(false)
                    setMixPersons(new Set())
                }}>取消</Button>
                <Button type='primary' disabled={mixPersons.size <= 1} onClick={e => {
                    e.preventDefault()
                    const persons = [...mixPersons]
                    confirm({
                        title: '将要合并' + persons.length + '个人物',
                        icon: <ExclamationCircleOutlined/>,
                        content: <Space wrap={true}>
                            {persons.map((person, index) => <>
                                <Image
                                    height={80}
                                    width={80}
                                    style={{objectFit: 'cover'}}
                                    src={person.properties?.face.imageUrl}
                                />
                                {index === 0 && <Text>{`<-`}</Text>}
                            </>)}
                        </Space>,
                        onOk() {
                            const ids = persons.map(person => person.id)
                            debugger
                            setLoading(true)
                            VscsApi.mixPersons(ids)
                                .onSuccess(() => {
                                    setMixMode(false)
                                    setMixPersons(new Set())
                                    window.location.reload()
                                })
                                .onComplete(() => {
                                    setLoading(false)
                                })
                        },
                        onCancel() {

                        },
                    });

                }}>保存</Button>
            </Space>
        }
    }

    return (<>
        <Card title="场所流量" loading={loading} extra={getMixModeButtons()}>
            <Column {...config} />

            <Divider/>

            <Space direction="vertical" split={<Divider/>}>
                {venues.map(venue => <div>
                    <h4 style={{cursor: 'pointer'}}
                        onClick={() => navigate('/vscs/venue?id=' + venue.guid)}>{venue.name} | {venue.properties?.region} | {venue?.properties?.persons?.length ?? 0}人</h4>
                    <Space wrap>
                        {venue?.properties?.persons?.map(person =>
                            <Card size="small"
                                  hoverable
                                  style={{width: 128}}
                                  onClick={() => handlePersonClick(person)}
                                  bodyStyle={mixMode && mixPersons.has(person) ? {
                                      backgroundColor: '#94bfff',
                                  } : {}}
                                  cover={<Image
                                      height={101}
                                      preview={false}
                                      src={person.properties?.face.imageUrl}
                                  />}>
                                <Text style={{
                                    fontSize: 13, margin: 0
                                }}>#{person.id}</Text>
                            </Card>)}
                    </Space>
                </div>)}
            </Space>
        </Card>
    </>)
}

export default VscsFlowHomePage